import { TransferProgress } from './transfer-progress';
import { Subject, Subscription } from 'rxjs';
import { TransferStatus } from './transfer-status';

export interface MTMDownloadExtraInfo {
  remainingTime?: number;
}

export class MTMFileDownload {
  id: string;
  name: string;
  owner: string;
  contentType: string;
  downloadParameters: any;
  displayName: string;
  url: string;
  status: string = TransferStatus.WAITING;
  size: number;
  percentage: number = 0;
  buffer: Uint8Array = new Uint8Array(0);
  startDate: number = +new Date();
  startIndex: number = 0;
  retryCount: number = 0;
  maxRetry: number = 3;
  isSilent: boolean = false;
  iconUrl?: string;
  lastProgressTime: number = 0;

  progress$: Subject<TransferProgress> = new Subject<TransferProgress>();
  done$: Subject<MTMFileDownload> = new Subject<MTMFileDownload>();
  currentRequest: Subscription = null;
  extraInfo: MTMDownloadExtraInfo = {};

  static fromFileRef(file: any): MTMFileDownload {
    const downloadItem = new MTMFileDownload();
    downloadItem.name = file.name;
    downloadItem.url = file.signedURL;
    downloadItem.contentType = file.contentType;
    downloadItem.size = file.size;
    downloadItem.displayName = file.displayName;
    return downloadItem;
  }
}
